import React from "react";
import { Link } from "react-router-dom";

const DiscountThree = () => {
  return (
    <section className='discount-three overflow-hidden'>
      <div className='container container-lg'>
        <div className='row gy-4'>
          <div className='col-xl-4 col-sm-6'>
            <Link
              to='/shop'
              className='discount-three-item bg-img rounded-16 overflow-hidden d-block text-decoration-none'
              style={{
                backgroundImage:
                  "url(assets/images/thumbs/discount-three-img1.png)",
              }}
            >
              <div className='discount-three-content text-start'>
                <h6 className='fw-semibold mb-0 max-w-375 text-black'>
                  FELTING
                  <span className='d-block'>BAG</span>
                </h6>
                <span
                  className='btn btn-black rounded-pill gap-8 mt-12 flex-align d-inline-flex py-6 px-16 text-sm'
                >
                  Shop Now
                  <span className='text-xl d-flex'>
                    <i className='ph ph-shopping-cart-simple' />
                  </span>
                </span>
              </div>
            </Link>
          </div>
          <div className='col-xl-4 col-sm-6'>
            <Link
              to='/shop'
              className='discount-three-item bg-img rounded-16 overflow-hidden d-block text-decoration-none'
              style={{
                backgroundImage:
                  "url(assets/images/thumbs/discount-three-img2.png)",
              }}
            >
              <div className='discount-three-content text-start'>
                <h6 className='fw-semibold mb-0 max-w-375 text-black'>
                  YARN
                  <span className='d-block'>MATERIALS</span>
                </h6>
                <span
                  className='btn btn-black rounded-pill gap-8 mt-12 flex-align d-inline-flex py-6 px-16 text-sm'
                >
                  Shop Now
                  <span className='text-xl d-flex'>
                    <i className='ph ph-shopping-cart-simple' />
                  </span>
                </span>
              </div>
            </Link>
          </div>
          <div className='col-xl-4 col-sm-6'>
            <Link
              to='/workshops'
              className='discount-three-item bg-img rounded-16 overflow-hidden d-block text-decoration-none'
              style={{
                backgroundImage:
                  "url(assets/images/thumbs/discount-three-img3.png)",
              }}
            >
              <div className='discount-three-content text-start'>
                <h6 className='fw-semibold mb-0 max-w-375 text-black'>
                  ARTFORM
                  <span className='d-block'>WORKSHOPS</span>
                </h6>
                <span
                  className='btn btn-black rounded-pill gap-8 mt-12 flex-align d-inline-flex py-6 px-16 text-sm'
                >
                  Join Now
                  <span className='text-xl d-flex'>
                    <i className='ph ph-calendar' />
                  </span>
                </span>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DiscountThree;
